import { getQBankStructureLevelLabelByCategory } from '@exam-management/common/utils';
import type {
  QBankStructureLevel,
  QBankStructureLevelItemWithLevel,
} from '@exam-management/qbs-provider';
import { Flex, ReadonlyField, styled } from '@shared/components';
import { useMemo } from 'react';

const LocationFieldsWrapper = styled(Flex)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

function getQBSLevelItemName(
  qbsLevel: QBankStructureLevel,
  qbsLevelItem?: QBankStructureLevelItemWithLevel,
) {
  if (!qbsLevel?.enabled) {
    return 'ไม่เปิดใช้งาน';
  }

  if (qbsLevelItem?.tag) {
    return qbsLevelItem.tag.name;
  }
  return 'ไม่ระบุ';
}

export interface LocationFieldsProps {
  qbsLevels: QBankStructureLevel[];
  qbsLevelItems: QBankStructureLevelItemWithLevel[];
}

export default function LocationFields(props: Readonly<LocationFieldsProps>) {
  const { qbsLevels, qbsLevelItems } = props;

  const orderedQbsLevels = useMemo(
    () => [...qbsLevels].sort((a, b) => a.level - b.level),
    [qbsLevels],
  );

  return (
    <LocationFieldsWrapper>
      {orderedQbsLevels.map((qbsLevel) => {
        const qbsLevelItem = qbsLevelItems.find(
          (item) => item.qBankStructureLevel.id === qbsLevel.id,
        );

        const levelItemName = getQBSLevelItemName(qbsLevel, qbsLevelItem);

        const categoryLabel = getQBankStructureLevelLabelByCategory(qbsLevel.category, {
          withEng: true,
        });

        return (
          <Flex
            key={qbsLevel.id}
            sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(1) }}
          >
            <ReadonlyField label={categoryLabel} content={levelItemName} maxLines={1} />
          </Flex>
        );
      })}
    </LocationFieldsWrapper>
  );
}
